<script lang="ts">
  import CheckCircle from "../icons/CheckCircle.svelte";
  import Loader from "../icons/Loader.svelte";
  import TrendStagnant from "../icons/TrendStagnant.svelte";
  import CrossCircle from "../icons/CrossCircle.svelte";
  import type { ClassValue } from "svelte/elements";

  export type BadgeVariant = "success" | "error" | "default" | "pending";

  interface Props {
    size?: "sm" | "md" | "lg";
    variant?: BadgeVariant;
    hasIcon?: boolean;
    label?: string;
    class?: ClassValue;
    title?: string;
  }

  let {
    size = "sm",
    variant = "default",
    hasIcon = true,
    label = "",
    class: className,
    ...rest
  }: Props = $props();

  let bgClass = $derived(
    {
      success: "bg-success-subtle-bg",
      error: "bg-error-subtle-bg",
      default: "bg-alpha-025",
      pending: "bg-warning-subtle-bg",
    }[variant],
  );

  let textClass = $derived(
    {
      success: `text-pri-800`,
      error: `text-sec-800`,
      default: `text-mono-800 $`,
      pending: "text-sec-700",
    }[variant],
  );
</script>

<div
  {...rest}
  class={[
    "flex h-fit w-fit items-center gap-1 rounded-full transition-colors duration-200",
    size === "sm"
      ? "gap 1.5 text-xs leading-4"
      : size === "md"
        ? "text-sm leading-4"
        : "text-base leading-5",
    bgClass,
    size === "sm" ? "px-1.5 py-0.5" : size === "md" ? "px-2 py-1" : "px-2.5 py-1",
    hasIcon ? (size === "lg" ? "pl-1.5" : size === "md" ? "pl-1" : "pl-[3px]") : "",
    className,
  ]}
>
  {#if hasIcon}
    <span class={textClass}>
      {#if variant === "success"}
        <CheckCircle />
      {:else if variant === "error"}
        <CrossCircle />
      {:else if variant === "pending"}
        <div class="animate-spin"><Loader /></div>
      {:else if variant === "default"}
        <TrendStagnant />
      {/if}
    </span>
  {/if}
  {#if label}
    <span class={textClass}>{label}</span>
  {/if}
</div>
